import "antd/lib/result/style";
import _Result from "antd/lib/result";
import "antd/lib/row/style";
import _Row from "antd/lib/row";
import "antd/lib/col/style";
import _Col from "antd/lib/col";
import "antd/lib/progress/style";
import _Progress from "antd/lib/progress";
import "antd/lib/spin/style";
import _Spin from "antd/lib/spin";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React from 'react';
import { useDispatch } from 'react-redux';
import Link from 'next/link';
import { retry } from 'redux/actions/pipeline';
import NotifyByEmail from './NotifyByEmail';
var Title = _Typography.Title,
  Text = _Typography.Text;
var pipelineStepsInfoByType = {
  gem2s: ['Downloading sample files', 'Preprocessing samples', 'Computing metrics', 'Converting samples', 'Preparing analysis', 'Uploading completed data'],
  seurat: ['Downloading RDS file', 'Processing Seurat object', 'Uploading completed data']
};
var GEM2SLoadingScreen = function GEM2SLoadingScreen(props) {
  var pipelineStatus = props.pipelineStatus,
    completedSteps = props.completedSteps,
    experimentId = props.experimentId,
    experimentName = props.experimentName,
    pipelineType = props.pipelineType,
    pipelineErrorMessage = props.pipelineErrorMessage,
    isCopying = props.isCopying;
  var pipelineStepsInfo = pipelineStepsInfoByType[pipelineType];
  var dispatch = useDispatch();
  var totalSteps = pipelineStepsInfo.length;
  var completedCount = completedSteps.length;
  var dataManagementPath = '/data-management';
  var relaunchExperiment = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(retry(experimentId));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function relaunchExperiment() {
      return _ref.apply(this, arguments);
    };
  }();
  var texts = {
    toBeRun: {
      status: 'toBeRun',
      title: 'Let\'s upload and pre-process your data.',
      subTitle: 'Your data needs to be uploaded and pre-processed before it can be explored. To begin, go to Insights.',
      image: '/undraw_To_the_stars_qhyy.svg',
      alt: 'A rocket ship ready for take-off.'
    },
    running: {
      status: 'running',
      title: ' ',
      subTitle: ' ',
      image: '/undraw_Dev_focus_re_6iwt.svg',
      alt: 'A woman working in front of a computer.'
    },
    error: {
      status: 'error',
      title: 'We\'ve had an issue while launching your analysis.',
      subTitle: pipelineErrorMessage || 'You can launch another analysis or retry to launch the current analysis.',
      image: '/undraw_Abstract_re_l9xy.svg',
      alt: 'A woman confusedly staring at an abstract drawing.'
    },
    subsetting: {
      status: 'running',
      title: ' ',
      subTitle: ' ',
      image: '/undraw_Dev_focus_re_6iwt.svg',
      alt: 'A woman working in front of a computer.'
    }
  };
  var _texts$pipelineStatus = texts[pipelineStatus],
    status = _texts$pipelineStatus.status,
    title = _texts$pipelineStatus.title,
    subTitle = _texts$pipelineStatus.subTitle,
    image = _texts$pipelineStatus.image,
    alt = _texts$pipelineStatus.alt;
  var renderExtra = function renderExtra() {
    if (pipelineStatus === 'toBeRun') {
      return __jsx(Link, {
        as: dataManagementPath,
        href: dataManagementPath,
        legacyBehavior: true,
        passHref: true
      }, __jsx(_Button, {
        type: "primary",
        key: "console"
      }, "Go to Insights"));
    }
    if (pipelineStatus === 'error') {
      return __jsx(_Space, {
        size: "large"
      }, __jsx(Link, {
        as: dataManagementPath,
        href: dataManagementPath,
        legacyBehavior: true,
        passHref: true
      }, __jsx(_Button, {
        type: "primary",
        key: "console"
      }, "Launch Another Analysis")), __jsx(_Button, {
        type: "primary",
        key: "console",
        onClick: relaunchExperiment
      }, "Re-launch Current Analysis"));
    }
    return __jsx(_Row, null, __jsx(_Col, {
      span: 8,
      offset: 8
    }, __jsx(_Space, {
      direction: "vertical",
      size: "large"
    }, __jsx("br", null), __jsx("div", null, __jsx(_Space, {
      direction: "vertical",
      style: {
        width: '100%'
      }
    }, isCopying ? __jsx(React.Fragment, null, __jsx(_Spin, {
      size: "large"
    }), __jsx(Text, {
      type: "secondary"
    }, "Copying dataset files")) : __jsx(React.Fragment, null, __jsx(_Progress, {
      strokeWidth: 10,
      type: "line",
      status: "active",
      percent: Math.floor(Math.min(completedCount, totalSteps) / totalSteps * 100)
    }), __jsx(Text, {
      type: "secondary"
    }, pipelineStepsInfo[completedSteps.length])))), __jsx("div", null, pipelineStatus === 'subsetting' && __jsx(Title, {
      level: 3
    }, "Subsetting cell sets into", __jsx("br", null), experimentName), pipelineStatus === 'running' && __jsx(Title, {
      level: 3
    }, "We're launching your analysis..."), __jsx(Text, {
      type: "secondary"
    }, "You can wait or leave this screen and check again later."), pipelineStatus === 'subsetting' && __jsx(Text, {
      type: "secondary"
    }, __jsx("br", null), "Your new project containing only the selected cell sets will be available in the Insights module")), __jsx(NotifyByEmail, {
      experimentId: experimentId
    }))));
  };
  return __jsx(_Result, {
    status: status,
    title: title,
    subTitle: subTitle,
    icon: __jsx("img", {
      width: 250,
      height: 250,
      alt: alt,
      src: image,
      style: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '50%'
      }
    }),
    extra: renderExtra()
  });
};
GEM2SLoadingScreen.defaultProps = {
  completedSteps: [],
  experimentId: null,
  experimentName: null,
  pipelineErrorMessage: null,
  isCopying: false
};
export default GEM2SLoadingScreen;